import { lazy } from 'react';

const ChargesPageConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/charges',
			component: lazy(() => import('./ChargesPage'))
		}
	]
};

export default ChargesPageConfig;